import Phaser from 'phaser';
import { Colors } from '../consts/Colors';

export default class ScoreContainer extends Phaser.GameObjects.Container {
    constructor(scene, x, y, { scoreBravo, scoreMauvais }) {
        // Create container
        super(scene, x, y, []);
        scene.add.existing(this);

        const background = this.scene.add.rexRoundRectangle(0, 0, 470, 192, 22, Colors.Elmt.Beige).setOrigin(0.5, 0)
        this.add(background);

        // Partie Bravo
        const fondGood = this.scene.add.rexRoundRectangle(32 - background.width/2, 58, 140, 52, 22, Colors.Elmt.Green).setOrigin(0, 0.5)
        this.add(fondGood);

        const iconGood = this.scene.add.image(fondGood.x + 10, fondGood.y - 1.5, 'icon_correct_blanc').setOrigin(0, 0.5)
        this.add(iconGood);

        let txt = "BONNE RÉPONSE"
        if (scoreBravo > 1) {
            txt = "BONNES RÉPONSES"
        }
        this.goodText = this.scene.add.text(fondGood.x + fondGood.width + 12, iconGood.y, txt, {
            font: "24px MassiliaExtraBold",
            color: Colors.Text.Green,
            resolution: 2
        }).setOrigin(0, 0.5)
        this.add(this.goodText);

        this.goodScore = this.scene.add.text(fondGood.x + 82, iconGood.y, scoreBravo, {
            font: "32px MassiliaRegular",
            color: Colors.Text.White,
            resolution: 2
        }).setOrigin(0.5)
        this.add(this.goodScore);

        // Partie Mauvais
        const fondBad = this.scene.add.rexRoundRectangle(fondGood.x, 134, 140, 52, 22, Colors.Elmt.Red).setOrigin(0, 0.5)
        this.add(fondBad);

        const iconBad = this.scene.add.image(iconGood.x, fondBad.y, 'icon_false_blanc').setOrigin(0, 0.5)
        this.add(iconBad);
        txt = "MAUVAISE RÉPONSE"
        if (scoreMauvais > 1) {
            txt = "MAUVAISES RÉPONSES"
        }

        this.badText = this.scene.add.text(this.goodText.x, fondBad.y, txt, {
            font: "24px MassiliaExtraBold",
            color: Colors.Text.Red,
            resolution: 2
        }).setOrigin(0, 0.5)
        this.add(this.badText);

        this.badNum = this.scene.add.text(this.goodScore.x, fondBad.y, scoreMauvais, {
            font: "32px MassiliaRegular",
            color: Colors.Text.White,
            resolution: 2
        }).setOrigin(0.5)
        this.add(this.badNum);

    }
}